/* eslint-disable no-underscore-dangle -- __-prefixed keys are pcb.alpha internals */
// adapted from https://dev.to/gethackteam/from-higher-order-components-hoc-to-react-hooks-2bm9

import _ from 'lodash';
import { useState, useEffect } from 'react';

import { clearExpandedRefs, expandRef } from '../data';
import prefetched from '../helpers/prefetched';

const refCache = {};

const prefetchedRef = ref => prefetched('refs', ref);

function useReference(refObj, ...args) {
  //console.log('useReference', refObj)
  const resolved = refObj?.__data || prefetchedRef(refObj?.__ref) || refCache[refObj?.__ref];
  const refCacheElement = _.cloneDeep(resolved);
  // eslint-disable-next-line react-compiler/react-compiler -- module-level ref cache
  refCache[refObj?.__ref] = refCacheElement;

  const [results, setResults] = useState(refCacheElement);
  const [loading, setLoading] = useState(refObj && !results);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchData() {
      if (refObj) {
        setLoading(true);
        try {
          const data = refCache[refObj?.__ref] = _.cloneDeep(await expandRef(refObj, ...args));
          if (data) {
            setResults(data);
            setError('')
          }
        } catch (error) {
          setError(error.message);
        }
        setLoading(false);
      }
    }
    if (refCacheElement) {
      setResults(refCacheElement);
      setError('')
    } else {
      fetchData();
    }
  }, [refObj?.__ref]);

  return refObj === null ? {
    error: '',
    loading: true,
    results: null
  } : {
    error,
    loading,
    results
  };
}

export default useReference;

const clearRefCache = () => {
  Object.keys(refCache).forEach(key => delete refCache[key]);
  clearExpandedRefs();
};

// this is to be used only in jest specs.  repeated calls to useReference MAY return a cached result in tests otherwise
// eslint-disable-next-line camelcase
export const TEST__clearRefCache = clearRefCache;

// refCache is module-level and never reset, so on a persistent SSR worker
// reused across many unrelated requests, a stale entry from one render can leak into a later
if (typeof window === 'undefined') {
  globalThis.clearSSRRefCache = clearRefCache;
}
